import Turbolinks from 'turbolinks';
class OnLoad {
  private static _instance: OnLoad;
  private constructor(){}
  public static get instance(): OnLoad {
    if(!this._instance) {
      this._instance = new OnLoad();
    }
    return this._instance;
  }

  public add(callback) {
    if (document.readyState !== 'loading') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
    document.addEventListener('turbolinks:load', callback);
  }
  public remove(callback) {
    document.removeEventListener('DOMContentLoaded', callback);
    document.removeEventListener('turbolinks:load', callback);
  }
  public addBefore(callback) {
    document.addEventListener('turbolinks:before-visit', callback);
  }
}

const onload = OnLoad.instance
export default onload;
